export default class AuthService
{
    static TOKEN: string = '';
    static USER = {
        id: -1,
        name: ''
    }
}